import { CommonFormProps } from "@interfaces/System/FormProps";
import { Checkbox, FormControlLabel, TextField } from "@material-ui/core";
import { Form, Formik } from "formik";
import React, { forwardRef } from "react";
import { CartItem } from "@interfaces/CartItem";
import { CartItemSchema } from "@schema/Cart";
import { Cart } from "@interfaces/Cart";
import { AsyncAutocomplete } from "@components/Controls/Autocomplete";
import { cartService } from "@services";

const CartItemForm = forwardRef(({ onSubmit, data }: CommonFormProps<CartItem>, ref: any) => {
    const initialData = {
        cart_id: data?.cart_id || null,
        sku: data?.sku || "",
        quantity: data?.quantity || null,
        excluded: data?.excluded || false,
    } as CartItem;

    return (
        <Formik
            initialValues={initialData}
            innerRef={ref}
            validationSchema={CartItemSchema}
            onSubmit={onSubmit}
            validateOnMount
        >
            {({ touched, errors, handleChange, setFieldValue, values }) => {
                return (
                    <Form>
                        <AsyncAutocomplete<Cart>
                            fetchFn={cartService.getCarts}
                            value={values.cart_id}
                            onChange={(name, value) => setFieldValue(name, value?.id || null)}
                            optionField="number"
                            textFieldProps={{
                                fullWidth: true,
                                required: true,
                                size: "small",
                                margin: "normal",
                                variant: "outlined",
                                name: "cart_id",
                                label: "Корзина",
                                helperText: touched.cart_id ? errors.cart_id : "",
                                error: touched.cart_id && !!errors.cart_id,
                            }}
                        />

                        {data && (
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={values.excluded}
                                        onChange={(e) => {
                                            handleChange(e);
                                        }}
                                        name="excluded"
                                        color="primary"
                                    />
                                }
                                label="Исключить из корзины"
                            />
                        )}

                        <TextField
                            fullWidth
                            onChange={handleChange}
                            required
                            value={values.sku || ""}
                            variant="outlined"
                            size="small"
                            margin="normal"
                            name="sku"
                            helperText={touched.sku ? errors.sku : ""}
                            error={touched.sku && !!errors.sku}
                            label="SKU"
                        />

                        <TextField
                            fullWidth
                            onChange={handleChange}
                            required
                            value={values.quantity || ""}
                            type="number"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            name="quantity"
                            helperText={touched.quantity ? errors.quantity : ""}
                            error={touched.quantity && !!errors.quantity}
                            label="Количество"
                        />
                    </Form>
                );
            }}
        </Formik>
    );
});

export default CartItemForm;
